import { render, staticRenderFns } from "./LinkSummary.vue?vue&type=template&id=05383180"
import script from "./LinkSummary.vue?vue&type=script&lang=js"
export * from "./LinkSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports